import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../customCheckbox';
import Textinput from '../textinput';
import TableCell from './tableCell';

import { isEmailValid } from '../../services/utils';
import { NotificationType } from '../../constants/notifications';

const transformWhiteList = arr =>
    arr.map(item => ({
        type: NotificationType.EMAIL,
        product_id: item,
    }));

const AddNonUserForm = ({ productsIds, companyId, cellWidth, joinNonUser, hideForm, addNonUser }) => {
    const [newUserEmail, setNewUserEmail] = useState('');
    const [newUserEmailError, setNewUserEmailError] = useState(false);
    const [whitelistEmail, setWhitelistEmail] = useState(productsIds);

    const onEmailChange = useCallback(e => {
        setNewUserEmail(e.target.value);
    }, []);

    const onSaveUser = useCallback(() => {
        if (newUserEmail && isEmailValid(newUserEmail)) {
            setNewUserEmailError(false);
            const whitelist = transformWhiteList(whitelistEmail);

            const args = {
                email: newUserEmail,
                whitelist,
            };

            addNonUser(args, companyId === 'non-users' ? joinNonUser : null);
            hideForm();
        } else {
            setNewUserEmailError(true);
        }
    }, [newUserEmail, whitelistEmail]);

    const onChangeNewUserCheckbox = useCallback(
        productId => {
            const index = whitelistEmail.indexOf(productId);

            if (index === -1) {
                return setWhitelistEmail([...whitelistEmail, productId]);
            }

            return setWhitelistEmail(whitelistEmail.toSpliced(index, 1));
        },
        [whitelistEmail],
    );

    const deselectAll = useCallback(() => {
        setWhitelistEmail([]);
    }, []);

    const selectAll = useCallback(() => {
        setWhitelistEmail(productsIds);
    }, []);

    const isAllSelected = productsIds.filter(id => !whitelistEmail.includes(id)).length === 0 && productsIds.length > 0;

    return (
        <div className="row">
            <div className="mn-label-holder">
                <div className="input-holder">
                    <Textinput
                        readOnly={false}
                        autoFocus
                        label=""
                        name="email"
                        buttonPadding
                        value={newUserEmail}
                        onChange={onEmailChange}
                        invalid={newUserEmailError}
                        type="email"
                    />
                    <div className="sq-button sq-button-save" onClick={onSaveUser} />
                </div>
            </div>
            <div className="mn-cells-holder">
                {productsIds && productsIds.length ? (
                    <React.Fragment>
                        <TableCell width={cellWidth} isSingleRow>
                            <Checkbox
                                color="blue"
                                checked={isAllSelected}
                                onChange={isAllSelected ? deselectAll : selectAll}
                            />
                        </TableCell>
                        {productsIds.map(id => (
                            <TableCell width={cellWidth} key={`prodVal${id}`} isSingleRow>
                                <Checkbox
                                    color="blue"
                                    checked={whitelistEmail.indexOf(id) !== -1}
                                    onChange={() => onChangeNewUserCheckbox(id)}
                                />
                            </TableCell>
                        ))}
                    </React.Fragment>
                ) : (
                    'No products'
                )}
            </div>
        </div>
    );
};

AddNonUserForm.propTypes = {
    companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    addNonUser: PropTypes.func.isRequired,
    joinNonUser: PropTypes.func.isRequired,
    productsIds: PropTypes.arrayOf(PropTypes.number).isRequired,
    hideForm: PropTypes.func.isRequired,
    cellWidth: PropTypes.shape({}),
};

export default React.memo(AddNonUserForm);



// WEBPACK FOOTER //
// ./source/components/manageNotifications/addNonUserForm.js